import { render, staticRenderFns } from "./LandingPageContiki.vue?vue&type=template&id=7ddbbd53&scoped=true&"
import script from "./LandingPageContiki.vue?vue&type=script&lang=js&"
export * from "./LandingPageContiki.vue?vue&type=script&lang=js&"
import style0 from "./LandingPageContiki.vue?vue&type=style&index=0&id=7ddbbd53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddbbd53",
  null
  
)

export default component.exports